package com.eladfinish.bible.contest.ui.components.toolbar.configuration.model

import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.graphics.vector.ImageVector
import dev.icerock.moko.resources.ImageResource

sealed interface ToolbarIcon {
    data class PainterIcon(val painter: Painter) : ToolbarIcon
    data class VectorIcon(val imageVector: ImageVector) : ToolbarIcon
    data class MokoImageIcon(val imageResource: ImageResource) : ToolbarIcon
}
